export default {
  data() {
    return {
      nodeId: null,
      nodeData: null,
    }
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();
  },
  methods: {
    getNodeId() {
      if (!this.nodeId) {
        this.nodeId = this.$refs.el.parentElement.parentElement.id.slice(5);
      }
      return this.nodeId;
    },
    getNodeData() {
      if (!this.nodeData) {
        this.nodeData = this.$df.getNodeFromId(this.nodeId);
      }
      return this.nodeData;
    },
    updateNodeData(patch) {
      if (!this.nodeData) return null;

      const editablePatch = patch || ["config", "storage", "required"].reduce(
        (result, key) => {
          if (Object.prototype.hasOwnProperty.call(this.nodeData.data, key)) {
            result[key] = this.nodeData.data[key];
          }
          return result;
        },
        {}
      );
      const data = this.$df.commitNodeData(this.nodeId, editablePatch);
      if (data) {
        this.nodeData = { ...this.nodeData, data };
      }

      return data;
    },
  },
}
